import { Inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as fromActions from './user-apps.actions';
import { ErrorHandlerService } from '../../../services/error-handler/error-handler.base-service';
import { UserAppsFacade } from '../../../services/account/user-apps/user-apps.facade';
import { IEnvironment } from '../../../models';

@Injectable()
export class UserAppsEffects {
  getUserRegisteredSaasResidentApps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.GetUserRegisteredSaasResidentApps),
      switchMap(() => {
        if (this.environment.customerIdent) {
          const registeredApps = [
            { customerIdent: this.environment.customerIdent, name: this.environment.appName },
          ];
          return of(fromActions.GetUserRegisteredSaasResidentAppSuccess({ registeredApps }));
        } else {
          return this.userAppsFacade.getUserRegisteredSaasResidentApps().pipe(
            map(registeredApps =>
              fromActions.GetUserRegisteredSaasResidentAppSuccess({
                registeredApps,
              })
            ),
            catchError((error: Error) => {
              this.errorHandlerService.handleError(
                '(REQUEST ERROR) on user-apps.effects.ts:getUserRegisteredSaasResidentApps$:',
                error
              );
              return [fromActions.GetUserRegisteredSaasResidentAppsFailed({ error })];
            })
          );
        }
      })
    )
  );

  loadCustomerIdent$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadCustomerIdent),
      switchMap(({ domain }) =>
        this.userAppsFacade.getCustomerIdent(domain).pipe(
          map(customerIdentBean =>
            fromActions.LoadCustomerIdentSuccess({
              customerIdent: customerIdentBean.customerIdent,
            })
          ),
          catchError((error: Error) => {
            this.errorHandlerService.handleError(
              '(REQUEST ERROR) on user-apps.effects.ts:LoadCustomerIdent:',
              error
            );
            return [fromActions.LoadCustomerIdentFailed({ error })];
          })
        )
      )
    )
  );

  loadCustomerIdentSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.LoadCustomerIdentSuccess),
      switchMap(({ customerIdent }) =>
        of(fromActions.SetSelectedCustomerIdent({ selectedCustomerIdent: customerIdent }))
      )
    )
  );

  constructor(
    @Inject('ENVIRONMENT') private environment: IEnvironment,
    private actions$: Actions,
    private userAppsFacade: UserAppsFacade,
    private errorHandlerService: ErrorHandlerService
  ) {}
}
